module.exports = import("https://cdn.jsdelivr.net/npm/gl-matrix@3.4.3/esm/index.js");;